import React from 'react';
import PageHeader from '../Components/common/PageHeader';
import {SEO} from "../Components/SEO/SEO";
import {Box, Link, List, ListItem} from "@chakra-ui/react";

const urls = [
    "https://www.merchantcircle.com/overland-park-tree-care-overland-park-ks",
    "https://ebusinesspages.com/Overland-Park-Tree-Care_emtyx.co",
    "https://foursquare.com/v/overland-park-tree-care/65e4a02eaab14615243efda5",
    "https://www.hotfrog.com/company/09024ea6cd7d740c418d843e72086dc7/overland-park-tree-care/overland-park/tree-removal",
    "https://www.webwiki.com/overlandparktreecare.com",
    "https://ezlocal.com/ks/overland-park/tree-service/0918037878",
    "https://overland-park-tree-care.hub.biz/",
    "https://i.imgur.com/lZ8Mx6s.png",
    "https://www.cityfos.com/company/Overland-Park-Tree-Care-in-Overland-Park-KS-23000450.htm",
    "https://us.enrollbusiness.com/BusinessProfile/6590165/Overland%20Park%20Tree%20Care",
    "https://www.manta.com/c/m1w7qjg/overland-park-tree-care",
    "https://www.2findlocal.com/b/15123269/overland-park-tree-care-overland-park-ks?message=changeSubmitted",
    "https://www.brownbook.net/business/52510987/overland-park-tree-care/",
    "https://www.townplanner.com/directory/236888/",
    "http://tupalo.com/en/overland-park-kansas/overland-park-tree-care",
    "https://www.find-us-here.com/businesses/Overland-Park-Tree-Care-Overland-Park-Kansas-USA/34010124/",
    "https://www.a-zbusinessfinder.com/business-directory/Overland-Park-Tree-Care-Overland-Park-Kansas-USA/34010124/",
    "https://www.callupcontact.com/b/businessprofile/Overland_Park_Tree_Care/8946992",
    "https://www.zeemaps.com/view?group=4932689&x=-89.977500&y=35.036000&z=13",
    "https://www.ailoq.com/overland-park-ks/overland-park-tree-care",
    "https://www.scribblemaps.com/maps/view/Overland-Park-Tree-Care/3At6VtSdQs",
    "http://www.askmap.net/location/6847793/united-states/overland-park-tree-care",
    "https://ks-overland-park.cataloxy.us/firms/overlandparktreecare.com.htm",
    "https://teleadreson.com/overland-park-tree-care,7300-west-110th-street-overland-park,ks-66210-VnWSAFZ1kgA.html",
    "https://www.yplocal.com/overland-park-ks/home-garden/overland-park-tree-care",
    "https://www.adlocalpages.com/overland-park-ks/home-garden/overland-park-tree-care",
    "https://www.nextbizthing.com/overland-park-ks/home-20-garden/overland-park-tree-care",
    "https://www.freelistingusa.com/listings/overland-park-tree-care",
    "http://www.travelful.net/location/5391488/united-states/overland-park-tree-care",
    "http://www.place123.net/place/overland-park-tree-care-overland-park-ks-united-states",
    "https://www.whodoyou.com/biz/2275453/overland-park-tree-care-ks-us",
    "https://unitedstateswebdesigndirectory.com/profile/overland-park-ks/overland-park-tree-care/14965",
    "http://overlandpark.bizlistusa.com/business/5405220.htm",
    "https://sites.bubblelife.com/community/overland_park_tree_care",
    "https://www.bunity.com/overland-park-tree-care",
    "https://smallbusinessusa.com/listing/wwwoverlandparktreecarecom.html",
    "https://www.iformative.com/product/overland-park-tree-care-p2428143.html",
    "https://www.cleansway.com/overland-park-ks/business/overland-park-tree-care",
    "https://companylistingnyc.com/listings/overland-park-tree-care/",
    "https://www.dealerbaba.com/suppliers/others/overland-park-tree-care.html",
    "https://www.freeads24.com/index.php?option=com_marketplace&page=show_ad&catid=0&adid=663711&Itemid=26",
    "https://www.40billion.com/company/350968028",
    "https://penzu.com/p/c477f37c09382285",
    "https://batchgeo.com/map/169db18920b415ce2d7dd74dfa0c0426",
    "https://www.evernote.com/shard/s326/sh/44ecb34c-23f3-addd-92c1-5b522f91c145/ElZIUMhW9cEVZM4xXpmtafgfVynHzrOanUKFwj5QkVyu_PwTQ5QDaU0Esw",
    "https://www.startus.cc/company/overland-park-tree-care",
    "https://thelocal.directory/business-directory/overland-park-tree-care/",
    "http://businessizze.com/directory/listingdisplay.aspx?lid=40791",
    "http://overlandpark.businesslistus.com/business/5405220.htm",
    "https://globalcatalog.com/overlandparktreecare.us",
    "https://geocha-production.herokuapp.com/maps/127471-overland-park-tree-care",
    "https://citysquares.com/b/overland-park-tree-care-25591000",
    "https://yellow.place/en/overland-park-tree-care-overland-park-ks-usa",
    "https://www.linkcentre.com/profile/overlandtreecare/",
    "https://overlandpark.yalwa.com/ID_141834204/Overland-Park-Tree-Care.html",
    "https://www.city-data.com/profiles/334465",
    "http://businessezz.com/directory/listingdisplay.aspx?lid=81298",
    "http://www.eliteservicesnetwork.com/overland-park-ks/home-services/overland-park-tree-care",
    "https://www.techdirectory.io/overland-park-ks/home-services/overland-park-tree-care",
    "http://seebusinesses.com/directory/listingdisplay.aspx?lid=39333",
    "http://www.hot-web-ads.com/view/item-15561052-Overland-Park-Tree-Care.html",
    "https://www.quora.com/profile/Overland-Park-Tree-Care-1",
    "http://www.servicezz.com/directory/listingdisplay.aspx?lid=59295",
    "https://www.classifiedads.com/home_services_stores/dzc1hckwk3dbb",
    "https://www.homify.com/ideabooks/9603441/overland-park-tree-care",
    "http://listingzz.com/directory/listingdisplay.aspx?lid=74443",
    "https://list.ly/list/9exd-overland-park-tree-care?make_list_mode=true",
    "https://www.n2local.com/us/ks/overland+park/services+offered/other/20240303214325dNWppK3e817",
    "https://www.southjordanjournal.com/events/283737/overland-park-tree-care",
    "https://issuu.com/overlandtreecare",
    "https://www.midvalejournal.com/events/283737/overland-park-tree-care",
    "http://greentornado.com/directory/listingdisplay.aspx?lid=52737",
    "http://www.northlandhq.com/directory/listingdisplay.aspx?lid=51454",
    "https://www.walnutcreekmagazine.com/events/283737/overland-park-tree-care",
    "https://www.localfeatured.com/directory/listingdisplay.aspx?lid=95752",
    "http://www.usnetads.com/view/item-132947687-Overland-Park-Tree-Care.html",
    "https://www.bunnydirectories.com/overland-park-ks/goods/overland-park-tree-care",
    "http://www.usaonlineclassifieds.com/view/item-2555995-Overland-Park-Tree-Care.html",
    "https://www.todaysfamilymagazine.com/events/283737/overland-park-tree-care",
    "https://justpaste.it/d8d4q",
    "https://www.ikeanded.com/directory/listingdisplay.aspx?lid=168050",
    "https://www.localhomeservicepros.com/overland-park-ks/home-improvement/overland-park-tree-care",
    "https://www.rswliving.com/events/283737/overland-park-tree-care",
    "https://target-directory.com/listing/overland-park-tree-care-995786",
    "https://www.gulfmainmagazine.com/events/283737/overland-park-tree-care",
    "http://www.click4homeservices.com/overland-park-ks/landscape-service/overland-park-tree-care",
    "https://www.sandyjournal.com/events/283737/overland-park-tree-care",
    "http://localpromoted.com/directory/listingdisplay.aspx?lid=70104",
    "https://www.triangledowntowner.com/events/283737/overland-park-tree-care",
    "https://www.announceamerica.com/overland-park-ks/home-and-garden/overland-park-tree-care",
    "http://northland101.com/directory/listingdisplay.aspx?lid=48623",
    "https://www.westjordanjournal.com/events/283737/overland-park-tree-care",
    "https://www.insertbiz.com/listing/overland-park-tree-care/",
    "https://www.houzz.com/pro/webuser-695630981/overland-park-tree-care",
    "https://www.greateruppervalley.com/events/283737/overland-park-tree-care",
    "https://telegra.ph/Overland-Park-Tree-Care-03-04",
    "http://localzz101.com/directory/listingdisplay.aspx?lid=52610",
    "https://sites.google.com/view/overlandparktreecare/home",
    "http://localzzhq.com/directory/listingdisplay.aspx?lid=69489",
    "https://www.getlisteduae.com/listings/overland-park-tree-care",
    "http://serviceizze.com/directory/listingdisplay.aspx?lid=36823"
]

const DirectoriesOnTheWeb = () => {
    return (
        <>
            <SEO/>
            <PageHeader header={"Find us on the web!"}/>
            <div className="main_wrapper">
                <Box py={20} mt={0}>
                    <List spacing={3} textAlign={'center'}>
                        {urls.map((url, index) => (
                            <ListItem key={index}>
                                <Link href={url} isExternal color="blue.500" target={"_blank"} rel={"noreferrer"}>
                                    {url}
                                </Link>
                            </ListItem>
                        ))}
                    </List>
                </Box>
            </div>
        </>
    );
};

export default DirectoriesOnTheWeb;